import React from "react";
import Footer from "../Footer";

const TermsAndConditions = (props) => {
  return (
    <>
      <div style={containerStyle}>
        <h1 style={headingStyle}>Terms & Conditions</h1>
        <p style={textStyle}>
          This document outlines the terms and conditions that govern your
          access to the Kiko Live platform. By registering, signing up, or
          accessing the Kiko Live platform, you agree to the terms outlined
          herein.
        </p>
        <p style={textStyle}>
          This agreement constitutes a legally binding agreement between you
          ("Seller", "Licensee", "User") and Kiko Live, a platform providing
          visibility to sellers within the ONDC network ("we", "us", "Kiko
          Live").
        </p>
        <h2 style={subHeadingStyle}>1. Kiko Live Platform</h2>
        <p style={textStyle}>
          The Kiko Live platform, including the associated website, mobile site,
          and mobile applications, provides visibility to sellers and
          facilitates their access to the ONDC buyer network. Kiko Live is a
          platform that allows sellers to list their products and interact with
          potential buyers but does not assume any liability or responsibility
          for transactions, including product quality, fulfillment, or payment,
          made through the ONDC network.
        </p>
        <p style={textStyle}>
          Kiko Live does not hold or manage any product inventory, nor does it
          assume any responsibility for the execution, fulfillment, or
          performance of transactions made between buyers and sellers. Kiko Live
          does not engage in the sale or delivery of any goods or services
          listed by the seller.
        </p>
        <h2 style={subHeadingStyle}>
          2. Transactions and Buyer-Seller Agreement
        </h2>
        <p style={textStyle}>
          Kiko Live is not a party to any transaction between the buyer and the
          seller. All terms related to the sale, including but not limited to
          product price, shipping, delivery, warranties, and after-sales
          services, are agreed upon exclusively between the buyer and the
          seller.
        </p>
        <p style={textStyle}>
          Kiko Live is not responsible for the performance of any transaction,
          nor does it make any guarantees regarding the product specifics, legal
          title, or quality of goods and services listed on the platform. Kiko
          Live also does not mediate disputes between buyers and sellers.
        </p>
        <h2 style={subHeadingStyle}>3. Liability</h2>
        <p style={textStyle}>
          Limitation of Liability: Kiko Live does not assume any liability for
          purchases made through the ONDC infrastructure. The responsibility for
          fulfilling all orders and ensuring compliance with applicable laws,
          including product delivery and customer satisfaction, rests solely
          with the seller. Kiko Live will not be held accountable for issues
          related to transactions, including but not limited to payment
          disputes, delivery failures, or product non-conformities.
        </p>
        <p style={textStyle}>
          Kiko Live's role is limited to offering visibility and providing
          access to the ONDC network, without any involvement in the commercial
          transactions between buyers and sellers.
        </p>
        <h2 style={subHeadingStyle}>4. Seller Responsibilities</h2>
        <p style={textStyle}>
          The seller acknowledges and agrees to the following:
        </p>
        <ul style={{ marginLeft: "20px", color: "#555", lineHeight: "1.6" }}>
          <li>
            <strong>Product Listings:</strong> Sellers are responsible for
            ensuring that all product listings are accurate, complete, and
            comply with applicable laws.
          </li>
          <li>
            <strong>Transaction Fulfillment:</strong> Sellers are solely
            responsible for fulfilling the orders they receive, including
            shipping, delivery, and product quality.
          </li>
          <li>
            <strong>Liability for Goods:</strong> Sellers bear full
            responsibility for any legal claims, including warranty, compliance,
            and product quality, and indemnify Kiko Live against any claims
            arising from their listings or transactions.
          </li>
          <li>
            <strong>ONDC Compliance:</strong> As a participant within the ONDC
            network, sellers are required to comply with ONDC's protocols and
            directives, including product catalog requirements and order
            fulfillment standards.
          </li>
        </ul>
        <h2 style={subHeadingStyle}>5. No Warranty or Endorsement</h2>
        <p style={textStyle}>
          Kiko Live does not make any representations or warranties regarding
          the accuracy or quality of the products listed on the platform or
          their compliance with applicable laws. Kiko Live does not endorse any
          seller or product, and any warranties or claims are solely the
          responsibility of the seller.
        </p>
        <h2 style={subHeadingStyle}>6. Indemnity</h2>
        <p style={textStyle}>
          The seller agrees to indemnify and hold Kiko Live harmless from any
          and all losses, liabilities, damages, costs, and expenses arising from
          or related to their use of the platform, including claims arising out
          of the sale of products or services listed on Kiko Live.
        </p>
        <h2 style={subHeadingStyle}>7. Modifications to Terms</h2>
        <p style={textStyle}>
          Kiko Live reserves the right to modify or update these Terms &
          Conditions at any time. Changes will be communicated to the seller via
          email or platform notifications, and continued use of the platform
          will be deemed acceptance of the modified terms.
        </p>
        <h2 style={subHeadingStyle}>8. Governing Law</h2>
        <p style={textStyle}>
          These Terms & Conditions are governed by the laws of India. Any
          disputes arising from the use of the Kiko Live platform shall be
          subject to the exclusive jurisdiction of courts in New Delhi, India.
        </p>
        <h2 style={subHeadingStyle}>9. Force Majeure</h2>
        <p style={textStyle}>
          Neither party shall be liable for any failure or delay in fulfilling
          obligations under this agreement if caused by events beyond their
          reasonable control, including but not limited to natural disasters,
          acts of war, or government regulations.
        </p>
      </div>
      <Footer />
    </>
  );
};

const containerStyle = {
  fontFamily: "Arial, sans-serif",
  margin: "20px auto",
  padding: "20px",
  maxWidth: "800px",
  border: "1px solid #ccc",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
};

const headingStyle = {
  textAlign: "center",
  color: "#333",
  marginBottom: "20px",
};

const subHeadingStyle = {
  color: "#444",
  margin: "15px 0 10px 0",
  fontSize: "18px",
  fontWeight: "bold",
};

const textStyle = {
  lineHeight: "1.6",
  color: "#555",
  marginBottom: "10px",
};

export default TermsAndConditions;
